import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';

import { AppState } from '../../../store/app-state';
import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { CommerceGeneralModel } from '../../model/CommerceGeneralModel';


@Component({
  selector: 'app-commerce-general-form',
  templateUrl: './commerce-general-form.component.html',
  styleUrls: ['./commerce-general-form.component.scss']
})
export class CommerceGeneralFormComponent extends FormBaseComponent<CommerceGeneralModel> implements OnInit {

  ownerList$
  addressTimeList$;

  @Input() showLogin = true;

  @Input() idTipoPersona: number = 0;
  @Input() commerceSat: object;


  @Input() postalCode: string;

  @Output() esPaso1Valido= new EventEmitter<boolean>();

  showLessor = false;
  personType = ''

  address = '';
  lessor = '';
  person = '';
  contact1 = '';
  contact2 = '';


  constructor(private store: Store<AppState>) {
    super();
    this.ownerList$ = this.store.select(state => state.list.owner)
    this.addressTimeList$ = this.store.select(state => state.list.addressTime)

    this.store.subscribe(state => {
      this.showLogin = !state.user.isAuth;
    });
  }

  ngOnInit() {
    this.init(true);
    /*this.form.statusChanges.subscribe(status=>{
      setTimeout(() => {
        this.esPaso1Valido.emit(status == 'VALID');
      }, 100);
    })*/
  }

  template() {
    this.form.addControl('commerce', new FormControl(null));
    this.form.addControl('addressTime', new FormControl(0));
    this.form.addControl('owner', new FormControl(0));
    this.form.addControl('contact', new FormControl(null));
    this.form.addControl('ownerName', new FormControl(null));
    this.form.addControl('municipality', new FormControl(null));
    this.form.addControl('operativeContact', new FormControl(null));
    this.form.addControl('user_email', new FormControl(''));
    this.form.addControl('user_password', new FormControl(''));
  }

  update(state) {
    this.showLessor = state.owner == '2';
  }

  updateTelfono(telefono){
    this.form.patchValue({
      personMoral: {
        phone: telefono
      }
    })
  }


  completeAddress(ownerAddress) {
    this.address = ownerAddress.street ? `${ownerAddress.street}, ${ownerAddress.numInt} - ${ownerAddress.numExt}, ${ownerAddress.colony}, ${ownerAddress.municipality}, ${ownerAddress.estate}` : '';
  }
  completeLessor(lessor) {
    this.lessor = lessor.name.length > 0 ? lessor.name + ' ' + lessor.secondName + ' ' + lessor.lastNamePaternal + ' ' + lessor.lastNameMaternal : ''
  }

  completeMoral(person) {
    this.person = person.socialRazon.length >= 0 ? person.socialRazon : '';
    this.personType = this.person.length > 0 ? 'moral' : '';
  }
  completePhysical(person) {
    let lessor = person.contact;
    this.person = lessor.name.length > 0 ? lessor.name + ' ' + lessor.secondName + ' ' + lessor.lastNamePaternal + ' ' + lessor.lastNameMaternal : ''
    this.personType = this.person.length > 0 ? 'physical' : '';
  }

  completeContact(data) {
    this.contact1 = data.operativeContact.name.length > 0 ? data.operativeContact.name + ' ' + data.operativeContact.secondName + ' ' + data.operativeContact.lastNamePaternal + ' ' + data.operativeContact.lastNameMaternal : ''
    this.contact2 = data.adminContact.name.length > 0 ? data.adminContact.name + ' ' + data.adminContact.secondName + ' ' + data.adminContact.lastNamePaternal + ' ' + data.adminContact.lastNameMaternal : '';
  }

}












// WEBPACK FOOTER //
// ./src/app/form/form/commerce-general-form/commerce-general-form.component.ts